import { CardBody } from "reactstrap";
import { QuickAccessData } from "../../../../../Data/Applications/FileManager/FileManager";
import { FileManagerBodyProps } from "../../../../../Types/FileManagerType";
import FolderListItem from "./FolderListItem";
import { H5, H6, LI, UL } from "../../../../../AbstractElements";

const FileManagerBody:React.FC<FileManagerBodyProps> = ({ myFile, fileList, searchFile }) => {
  return (
    <CardBody className="file-manager">
      {!searchFile && (
        <>
          <H5 className="mb-2">{"Quick Access"}</H5>
          <UL className="quick-file simple-list flex-row">
            {QuickAccessData.map((item) => (
              <LI key={item.id}>
                <div className="quick-box">
                  <i className={item.quickClass}></i>
                </div>
                <H6>{item.quickTitle}</H6>
              </LI>
            ))}
          </UL>
          <H5 className="mt-4 mb-2">{"Folders"}</H5>
          <UL className="folder simple-list flex-row">
            {myFile.map((item) => (
              <FolderListItem key={item.id} item={item} />
            ))}
          </UL>
        </>
      )}
      <H5 className="mt-4 mb-2">{"Files"}</H5>
      <UL className="simple-list flex-row files-content">{fileList}</UL>
    </CardBody>
  );
};
export default FileManagerBody;
